exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.console-box[data-v-3ddb6ec8] {\n}\n.outputs[data-v-3ddb6ec8] {\n    white-space: pre-wrap;\n    word-break: break-all;\n    overflow-y: auto;\n    height: 100%;\n    padding: 0.2rem;\n}\n.outputs-padded[data-v-3ddb6ec8] {\n    padding: 1rem;\n}\n.output-error[data-v-3ddb6ec8] {\n    color: #fd7358;\n}\n.output-grade[data-v-3ddb6ec8] {\n    color: #60afee\n}\n", ""]);

// exports
